import PropTypes from 'prop-types';
export const tilesListPropTypes = {
  heading: PropTypes.string,
  classname: PropTypes.string,
  external: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    description: PropTypes.string,
    picture: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }))
};